

export function clearData() {
	localStorage.clear();
}